module.exports = __webpack_public_path__ + "img/mobileintegrated5.d3be5e8f.png";